
import { UserAvatar } from "@/components/layout/UserAvatar";
import { Logo } from "@/components/layout/Logo";
import { NotificationsPopover } from "@/components/notifications/NotificationsPopover";
import { useHeaderData } from "@/hooks/useHeaderData";
import { cn } from "@/lib/utils";

interface HeaderProps {
  avatar?: string | null;
  name?: string;
  variant?: "default" | "purple";
}

export function Header({ 
  avatar = null, 
  name = "JD", 
  variant = "default" 
}: HeaderProps) {
  const { avatar: storedAvatar, name: storedName } = useHeaderData(avatar, name);
  
  const headerClasses = cn(
    "h-16 border-b border-white/10 backdrop-blur-lg px-6 flex items-center justify-between sticky top-0 z-50 w-full",
    variant === "default" ? "bg-white/5" : "bg-purple-950/30"
  );
  
  return (
    <header className={headerClasses}>
      <Logo />
      
      <div className="flex items-center space-x-4">
        <NotificationsPopover />
        <UserAvatar avatar={storedAvatar} name={storedName} />
      </div>
    </header>
  );
}
